import { Grid, Text } from '@simplywallst/ui-core';
import { SliderTrackBand, sliderTrackGridTemplateColumns } from '../utils';

type Props = {
  bands: SliderTrackBand[];
};

export const SliderLabels = ({ bands }: Props) => {
  return (
    <Grid
      paddingTop="x2"
      templateColumns={sliderTrackGridTemplateColumns(bands)}
    >
      {bands.map(({ label, threshold, align }) => (
        <Grid key={threshold} justifyItems={align}>
          <Text as="span" typography="tiny" color="textSubtle">
            {label}
          </Text>
        </Grid>
      ))}
    </Grid>
  );
};
